import { rrulestr } from "rrule";

/**
 * Client-side mirror of `validateHolidayRrule` in
 * `libs/server-helpers/src/Schedule/validateHolidayRrule.ts`, which the server
 * uses to reject bad rules at save time. It's duplicated rather than shared
 * because the only library both apps can import (`libs/helpers`) also ships in
 * the customer widget, and `rrule` would add ~13 KB gzipped there for code the
 * widget never runs. Keep the two in sync; the server copy has the tests.
 *
 * Returns a user-facing error message, or `undefined` when the rule is usable.
 * Parsing alone isn't enough: rules like Feb 30 parse cleanly but never produce
 * a date, so a rule must have at least one upcoming occurrence.
 */
export function validateHolidayRrule(rrule: string): string | undefined {
  if (!rrule.trim()) return "Enter a recurrence rule.";
  try {
    // Same epoch anchor the server's matcher applies before parsing.
    const anchored = /^DTSTART/i.test(rrule.trim()) ? rrule : `DTSTART:19700101T000000Z\nRRULE:${rrule.trim().replace(/^RRULE:/i, "")}`;
    const next = rrulestr(anchored).after(new Date(), true);
    return next ? undefined : "This rule doesn't fall on any upcoming date.";
  } catch {
    return "This isn't a valid recurrence rule. Example: FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25";
  }
}
